// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/style.css
// module id = 144
// module chunks = 0